module.exports = __webpack_public_path__ + "img/qwen-batch-lamp-02.5a895198.webp";